import { call, put, takeLatest, all, select, delay } from 'redux-saga/effects';
import * as neway from 'api/neway';
import getConfig from 'next/config';
import { PENSION_ANALYSIS_CALCULATION_RESET, PENSION_ANALYSIS_CALCULATION_REQUEST, PENSION_ANALYSIS_CALCULATION_SUCCESS, PENSION_ANALYSIS_CALCULATION_FAIL } from '../constants/calculations';
import * as tealCalculationApi from '../../api/neway';
import { getPensionAnalysis } from '../../api/neway';

function* calculateRecommendations() {
    const { scrapes, latestScrape } = yield select(state => state.scrapeData);
    const user = yield select(state => state.user);
    const { publicRuntimeConfig } = getConfig();
    let pensionHistory;
    let pensionAnalysis;
    if(scrapes.length === 0){
        yield put({
            type: PENSION_ANALYSIS_CALCULATION_RESET,
        });
        return;
    }
    try {
        // retry due to race condition for update user after getting scrape
        yield delay(500);
        if(publicRuntimeConfig.localCalculationApi){
            const extraInput = {
                incomePerMonthBeforeTax: user?.data.income?.base?.incomePerMonthBeforeTax,
                pensionAge: user?.data?.pension?.base?.pensionAge,
                folkepensionCalculationInput: user?.data?.pension?.folkepensionCalculationInput,
            };
            pensionAnalysis =  yield call(tealCalculationApi.pensionAnalysis, { scrape: latestScrape, extraInput });
        } else {
            pensionAnalysis = yield call(getPensionAnalysis);
        }


        if (scrapes.length > 1) {
            // if call fails continue with analysis only
            try {
                pensionHistory = yield call(tealCalculationApi.pensionHistory, { scrapes, userId: user.userId });
            } catch (e) {
                console.error(e);
            }
        }
        // retry due to race condition when creating new user, there is risk of showing old analysis for repeat upload scenarios that this does not solve.
        if(!pensionAnalysis){
            yield delay(1000);

            pensionAnalysis = yield call(getPensionAnalysis);
            if(!pensionAnalysis){
                yield delay(2000);
                pensionAnalysis = yield call(getPensionAnalysis);
            }
        }
        yield put({
            type: PENSION_ANALYSIS_CALCULATION_SUCCESS,
            payload: { pensionAnalysis, pensionHistory },
        });
        const calculatedAge = pensionAnalysis.keyFigures.pensionAge - pensionAnalysis.keyFigures.yearsUntilPension;

        if (user.data?.age !== calculatedAge) {
            try {
                const updatedUser = yield call(neway.updateUserData, 'age', calculatedAge);
                yield put({
                    type: 'USER_UPDATED',
                    payload: { user: updatedUser },
                });
            } catch (e) {
                console.error(e);
            }
        }

        try {
            const updatedUser = yield call(neway.updateUserData, 'pension', { history: pensionHistory });
            yield put({
                type: 'USER_UPDATED',
                payload: { user: updatedUser },
            });
        } catch (e) {
            console.error(e);
        }
    } catch (error) {
        yield put({ type: PENSION_ANALYSIS_CALCULATION_FAIL, payload: error });
    }
}

export default function* calculationsSaga() {
    yield all([takeLatest(PENSION_ANALYSIS_CALCULATION_REQUEST, calculateRecommendations),
        takeLatest('FILE_DELETE_SUCCESS', calculateRecommendations)]);
}
